module.exports = __webpack_public_path__ + "img/svg/map-pin.4dfdca3afff87454ae27cce7287ee534.svg";